import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';

import { ActionQueueModule } from './automated-user-management/action-queue/action-queue.module';
import { AutomatedUserManagementBannerModule } from './automated-user-management/banner/banner.module';
import { CSVUploadModule } from './automated-user-management/csv-upload/csv-upload.module';
import { MembersCardsListModule } from './members-cards-list/members-cards-list.module';
import { MembersTableModule } from './members-table/members-table.module';
import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { LocationAutocompleteModule } from '@libs/src/location-autocomplete/location-autocomplete.module';
import { ToastModule } from '@libs/src/toast/toast.module';
import { TtcMatInputModule } from '@libs/src/ttc-mat-input/ttc-mat-input.module';
import { DeleteAccountsDialogModule } from '@main-client/src/app/delete-accounts-dialog/delete-accounts-dialog.module';
import { GroupMembersDownloadModule } from '@main-client/src/app/group-members-download/group-members-download.module';
import { GroupMembershipPipeModule } from '@main-client/src/app/pipes/group-membership-pipe/group-membership-pipe.module';
import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';
import { RemoveMembersFromHubDialogModule } from '@main-client/src/app/remove-members-from-hub-dialog/remove-members-from-hub-dialog.module';

import { ActionQueueService } from './automated-user-management/action-queue/action-queue.service';
import { MembersEffects } from './members-effects.service';

import { ActionQueueComponent } from './automated-user-management/action-queue/action-queue.component';
import { CSVUploadViewComponent } from './automated-user-management/csv-upload/csv-upload.component';
import { MembersFiltersDialogComponent } from './members-filters-dialog.component';
import { MembersComponent } from './members.component';

import { membersReducer } from '@libs/src/accounts/members.reducer';

import { AdminGroupsModule } from '../core/admin-groups.module';
import { CoreModule } from '../core/core.module';
import { ProgramParticipantsFilterModule } from '../program-participants-filter/program-participants-filter.module';
import { ProgressSpinnerModule } from '../progress-spinner/progress-spinner.module';

@NgModule({
  declarations: [MembersComponent, MembersFiltersDialogComponent],
  exports: [MembersComponent],
  providers: [ActionQueueService],
  imports: [
    ActionQueueModule,
    AdminGroupsModule,
    AutomatedUserManagementBannerModule,
    AvatarModule,
    CommonModule,
    CoreModule,
    CSVUploadModule,
    DeleteAccountsDialogModule,
    FlexLayoutModule,
    EffectsModule.forFeature([MembersEffects]),
    GroupMembersDownloadModule,
    GroupMembershipPipeModule,
    LocationAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    MatSelectModule,
    MatTabsModule,
    MembersCardsListModule,
    MembersCardsListModule,
    MembersTableModule,
    NzTableModule,
    NzTabsModule,
    ProgramParticipantsFilterModule,
    ProgressSpinnerModule,
    ReactiveFormsModule,
    RemoveMembersFromHubDialogModule,
    RouterModule.forChild([
      {
        component: CSVUploadViewComponent,
        path: 'import-membership-file',
      },
      {
        component: ActionQueueComponent,
        path: 'import-membership-file/review',
      },
    ]),
    StoreModule.forFeature('members', membersReducer),
    ToastModule,
    TranslationLookupModule,
    TtcMatInputModule,
  ],
})
export class MembersModule {}
